import { createVoltraComponent } from './createVoltraComponent.js'
import type { CircularProgressViewProps } from './props/CircularProgressView.js'

export type { CircularProgressViewProps }
export const CircularProgressView = createVoltraComponent<CircularProgressViewProps>('CircularProgressView')
